import { AppointmentStatus } from './appointment.type'

export type BillingNote = {
  noteId: string
  author: string
  content: string
  date: string
}

export type BillingPaymentNotePayload = {
  title?: string
  content?: string
  body?: string
  tag?: string
  date?: string | Date
}

export type BillingAttachment = {
  id: string
  fileName: string
  size?: number
  dateUploaded: string
  progress?: number
  notes?: BillingNote[]
}

export type BillingProcedure = {
  procedureLogId: string
  procedureCode: string
  description: string
  clinicFee: number
  allowedAmount: number | null
  writeOff: number | null
  estimatedInsurance: number | null
  approvedInsurance: number | null
  insuranceBalance: number | null
  insuranceAdjustment: number | null
  insuranceCash: number | null
  discount: number | null
  patientResponsibility: number
  patientAdjustment: number | null
  patientBalance: number | null
  patientCash: number | null
  toothDetails?: string | null
}

export type LedgerEntry = {
  appointmentId: string
  patientName: string
  invoiceNumber: string
  providerName: string
  appointmentDate: string
  approvedInsurance: number | null
  insuranceBalance: number | null
  patientResponsibility: number
  patientBalance: number
  appointmentBalance: number
  // ------------------------------------------
  clinicFee: number
  allowedAmount: number | null
  writeOff: number | null
  estimatedInsurance: number | null
  discount: number | null
  appointmentAdjustment: number | null
  // ------------------------------------------
  appointmentType: string
  appointmentStatus: AppointmentStatus
  claimSubmitted: number | null
  claimId: string | null
  claimStatus: string | null
  billingStatus: string | null
  paidBy: string | null
  paymentMethod: string | null
  paymentDate: string | null
  insuranceAdjustmentType: string | null
  patientAdjustmentType: string | null
  status: PaymentStatus
  // ------------------------------------------
  procedures: BillingProcedure[]
  notes?: BillingNote[]
  attachments?: BillingAttachment[]
}

export type InvoiceEntry = {
  invoiceNo: string
  invoiceDate: string
  patientName: string
  charges: number
  approvedInsurance: number
  appointmentAdjustment: number
  patientResponsibilityTotal: number
  patientResponsibilityBalance: number
  discount: number
  status: PaymentStatus
  ledgerEntries: LedgerEntry[]
  // Clinic Information
  clinicName?: string
  clinicAddress?: string
  clinicCity?: string
  clinicState?: string
  clinicZip?: string
  // Patient Address Information
  patientAddress?: string
  patientCity?: string
  patientState?: string
  patientZip?: string
  // Due Date
  dueDate?: string
}

export enum PaymentType {
  CASH = 'Cash',
  CARD = 'Card',
  ONLINE = 'Online',
}

export enum AmountType {
  Full = 'Full',
  Partial = 'Partial',
}

export enum PaymentStatus {
  Paid = 'Paid',
  Unpaid = 'Unpaid',
  PartiallyPaid = 'Partially paid',
}

export enum BalanceBadgeStatus {
  Paid = 'paid',
  Unpaid = 'unpaid',
  Partial = 'partial',
}

export type PaymentEntry = {
  paymentId: string
  invoiceId: string
  paymentDate: string
  amountDue: number
  amountPaid: number
  method: PaymentType
  paidBy: string
  referenceNumber?: string | null
}

export type Patient = {
  patientId: string
  patientName: string
  dateOfBirth: string
}
